module.exports = __webpack_public_path__ + "media/images/marcador_ioscor-ca9b8252bf10dd91be91a9acf00b8f18.png";